/** Normalizes the legacy grouped and newer flat GetFormElements contracts. */
import type { FormElementItem } from '../models/form';

function record(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};
}

export function normalizeFormElementsResponse(value: unknown): FormElementItem[] {
  if (!Array.isArray(value)) return [];
  const candidates: unknown[] = [];
  for (const item of value) {
    const source = record(item);
    if (Array.isArray(source.Options)) candidates.push(...source.Options);
    else candidates.push(item);
  }

  const output: FormElementItem[] = [];
  const seen = new Set<string>();
  for (const item of candidates) {
    const source = record(item);
    const model = typeof source.Model === 'string' ? source.Model.trim() : '';
    if (!model || seen.has(model)) continue;
    seen.add(model);
    const name = typeof source.Name === 'string' ? source.Name.trim() : '';
    const title = typeof source.Title === 'string' ? source.Title.trim() : '';
    const fullModel = typeof source.FullModel === 'string' ? source.FullModel.trim() : '';
    const tag = typeof source.Tag === 'string' ? source.Tag.trim() : '';
    output.push({
      Name: name || model,
      Title: title || name || model,
      Model: model,
      FullModel: fullModel,
      Tag: tag
    });
  }
  return output;
}
